import { ReactNode } from 'react';
import { Colors } from '@zep/ui-tokens';
import S from './FormLayout.module.scss';
export const FormLayout = (props: FormLayoutProps) => {
  const {
    subtitle,
    title,
    children
  } = props;
  return <>
      <div className={S.layout}>
        <header className={S.header}>
          <h1 className={S.title}>
            <sup>{subtitle}</sup>
            <span>{title}</span>
          </h1>
        </header>
        <main className={S.main}>{children}</main>
      </div>
      <style jsx global>{`
        body {
          background-color: ${Colors.Gray50};
        }
      `}</style>
    </>;
};
type FormLayoutProps = {
  subtitle: string;
  title: string;
  children: ReactNode;
};